import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { DICTS, detectInitialLocale, STORAGE_KEY } from '../i18n';

const I18nContext = createContext(null);

function getPath(obj, path) {
  return path.split('.').reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
}

function interpolate(str, vars) {
  if (typeof str !== 'string' || !vars) return str;
  return str.replace(/\{\{(\w+)\}\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : `{{${k}}}`));
}

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => detectInitialLocale());

  const setLocale = useCallback((code) => {
    if (!DICTS[code]) return;
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (_) {
      /* ignore */
    }
    setLocaleState(code);
  }, []);

  const t = useCallback(
    (path, vars) => {
      const dict = DICTS[locale] || DICTS.en;
      let val = getPath(dict, path);
      if (val === undefined) val = getPath(DICTS.en, path);
      if (typeof val === 'string') return interpolate(val, vars);
      return path;
    },
    [locale]
  );

  const value = useMemo(() => ({ locale, setLocale, t }), [locale, setLocale, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error('useI18n must be used within I18nProvider');
  }
  return ctx;
}
